import React from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';

const SearchableSelect = ({
  loadOptions,
  value,
  onChange,
  placeholder,
  isMulti = false,
  isClearable = true,
  styles,
  isLoading: externalLoading
}) => {
  // Функция для загрузки опций с поддержкой пагинации
  const loadOptionsPaginate = async (inputValue, loadedOptions, { page }) => {
    const searchQuery = inputValue || '';
    const result = await loadOptions({ searchQuery, page: page || 1, objectsCount: 20 });
    const options = result || [];
    return {
      options,
      hasMore: options.length === 20,
      additional: {
        page: (page || 1) + 1,
      },
    };
  };

  return (
    <AsyncPaginate
      value={value}
      onChange={onChange}
      loadOptions={loadOptionsPaginate}
      additional={{ page: 1 }}
      isMulti={isMulti}
      isClearable={isClearable}
      placeholder={placeholder}
      styles={styles}
      isLoading={externalLoading}
      cacheUniqs={[styles]}
      noOptionsMessage={({ inputValue }) =>
        inputValue ? 'Ничего не найдено' : 'Загрузка...'
      }
      loadingMessage={() => 'Загрузка...'}
      closeMenuOnSelect={!isMulti}
      defaultOptions
    />
  );
};

export default SearchableSelect; 